import script from "./DesktopLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopLayout.vue?vue&type=script&setup=true&lang=js"

import "./DesktopLayout.vue?vue&type=style&index=0&id=766dafda&lang=scss"

const __exports__ = script;

export default __exports__